/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './intra-op-recovery.reducer';

export const IntraOPRecoveryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const intraOPRecoveryEntity = useAppSelector(state => state.intraOPRecovery.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="intraOPRecoveryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.intraOPRecovery.detail.title">IntraOPRecovery</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.id">Id</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.id}</dd>
          <dt>
            <span id="levelOfRecovery">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.levelOfRecovery">Level Of Recovery</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.levelOfRecovery}</dd>
          <dt>
            <span id="coherence">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.coherence">Coherence</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.coherence}</dd>
          <dt>
            <span id="reflexes">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.reflexes">Reflexes</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.reflexes}</dd>
          <dt>
            <span id="headLift">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.headLift">Head Lift</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.headLift}</dd>
          <dt>
            <span id="saeaSenosoryLevel">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.saeaSenosoryLevel">Saea Senosory Level</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.saeaSenosoryLevel}</dd>
          <dt>
            <span id="saeaMotorLevel">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.saeaMotorLevel">Saea Motor Level</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.saeaMotorLevel}</dd>
          <dt>
            <span id="patientReferredTo">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.patientReferredTo">Patient Referred To</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.patientReferredTo}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.active">Active</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.intraOPRecovery.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{intraOPRecoveryEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPRecovery.surgery">Surgery</Translate>
          </dt>
          <dd>{intraOPRecoveryEntity.surgery ? intraOPRecoveryEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPRecovery.surgeon">Surgeon</Translate>
          </dt>
          <dd>{intraOPRecoveryEntity.surgeon ? intraOPRecoveryEntity.surgeon.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPRecovery.scrubNurse">Scrub Nurse</Translate>
          </dt>
          <dd>{intraOPRecoveryEntity.scrubNurse ? intraOPRecoveryEntity.scrubNurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPRecovery.vitals">Vitals</Translate>
          </dt>
          <dd>{intraOPRecoveryEntity.vitals ? intraOPRecoveryEntity.vitals.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/intra-op-recovery" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/intra-op-recovery/${intraOPRecoveryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntraOPRecoveryDetail;
